import { all, call, fork, put, takeLatest } from "redux-saga/effects";
import {
  GET_NOTIFICATION_COUNT_REQUEST,
  GET_NOTIFICATION_LIST_REQUEST,
  READ_NOTIFICATION_REQUEST,
} from "./type";
import {
  getNotificationCountSuccess,
  getNotificationListRequest,
  getNotificationListSuccess,
  readNotificationSuccess,
} from "./action";
import { handleApiCallException } from "../shared/action";
import { invokeApi } from "../../helper/axiosHelper";

/* These endpoints live in vendor_portal, so the calls carry the "vendor"
   prefix - but both portals use them. invokeApi already picks the right token
   from the path the browser is on, so an admin page sends the admin token and
   the API answers with that admin's notifications. */
const notificationApi = (url, data) =>
  call(invokeApi, "post", url, data || {}, null, "vendor");

function* notificationList({ payload: data }) {
  try {
    const res = yield notificationApi("/notificationList", data);
    if (res.status) {
      yield put(getNotificationListSuccess(res.data));
    } else {
      yield put(getNotificationListSuccess({ list: [], unreadCount: 0 }));
    }
  } catch (error) {
    yield put(getNotificationListSuccess({ list: [], unreadCount: 0 }));
    handleApiCallException(error);
  }
}

/* The badge alone. Deliberately silent about failures: it polls in the
   background, and a toast on every hiccup would be worse than a stale count. */
function* notificationCount() {
  try {
    const res = yield notificationApi("/notificationUnreadCount");
    if (res.status) {
      yield put(getNotificationCountSuccess(res.data));
    }
  } catch (error) {
    /* leave the count as it was */
  }
}

function* readNotification({ payload: data }) {
  try {
    const res = yield notificationApi("/notificationRead", {
      notificationId: data?.notificationId,
    });
    if (res.status) {
      yield put(readNotificationSuccess(res.data?.data || res.data));
      /* the rows themselves have to come back too, or the panel would still
         show the ones just marked as unread */
      yield put(getNotificationListRequest(data?.listData));
    }
  } catch (error) {
    handleApiCallException(error);
  }
}

function* watchNotificationRequest() {
  yield takeLatest(GET_NOTIFICATION_LIST_REQUEST, notificationList);
  yield takeLatest(GET_NOTIFICATION_COUNT_REQUEST, notificationCount);
  yield takeLatest(READ_NOTIFICATION_REQUEST, readNotification);
}

function* NotificationSaga() {
  yield all([fork(watchNotificationRequest)]);
}

export default NotificationSaga;
